import { toShopDomain } from "./shop";
import type { FirestorePaths } from "../consts/db";

export function getFirestorePath(
  path: FirestorePaths,
  params?: Record<string, string>
): string {
  if (!params) return path;
  return path.replace(/\{(\w+)\}/g, (_, key) => {
    let value = params[key];
    if (value === undefined) {
      throw new Error(`Missing parameter: ${key}`);
    }
    if (key === "shop") {
      value = toShopDomain(value);
    }
    return value;
  });
}
